import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import { showErrorMessage } from "../Shared/Toast";

function MoverTypes() {
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({});
  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    getScreenData();
  }, []);

  function getScreenData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL + "api/MNVMoverType/MNVMoverTypeGetCompleteGridData"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false
          );
          if (selectedMoverID && selectedMoverID > 0) {
            l_oResponse = FilterJsonExactlyMatching(
              l_oResponse,
              "MNVMoverID",
              selectedMoverID
            );
          }
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
          // console.log(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (!addEditObject.Name || addEditObject.Name == 0) {
      showErrorMessage("Name required");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVMoverTypeID = addEditObject.MNVMoverTypeID;
    object.isactive = addEditObject.IsActive;
    object.MNVMoverID = addEditObject.MNVMoverID;
    object.Name = addEditObject.Name;
    object.DTPPerMileRate = addEditObject.DTPPerMileRate;
    object.PTDPerMileRate = addEditObject.PTDPerMileRate;
    object.DTDPerMileRate = addEditObject.DTDPerMileRate;
    object.LocalMovePerHourRate = addEditObject.LocalMovePerHourRate;
    object.DTPPerHourRate = addEditObject.DTPPerHourRate;
    object.PTDPerHourRate = addEditObject.PTDPerHourRate;
    object.DTDPerHourRate = addEditObject.DTDPerHourRate;
    object.LoadingUnloadingPerHourRate =
      addEditObject.LoadingUnloadingPerHourRate;
    object.PerStairRate = addEditObject.PerStairRate;

    object.IsContractor = false;
    object.CreatedByID = 0;
    object.LastUpdatedByID = 0;
    object.IsDeleted = false;
    axiosAuth
      .post(AppContext.APIURL + "api/MNVMoverType/MNVMoverTypeSave", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNew(0);
            getScreenData();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVMoverTypeID = pid;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVMoverType/MNVMoverTypeDeleteRecord",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Name")) {
        (
          document.getElementById("imgSort" + "Name") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "IsActive")) {
        (
          document.getElementById("imgSort" + "IsActive") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "CreatedByName")) {
        (
          document.getElementById(
            "imgSort" + "CreatedByName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({});
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblmovertypes", "Mover Types")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tblmovertypes">
              <thead>
                <tr>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Name
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Name")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Name")}
                          title={"Sort By Mover Type"}
                        >
                          <span id={"imgSort" + "Name"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Is Active
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "IsActive")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("IsActive")}
                          title={"Sort By Base"}
                        >
                          <span id={"imgSort" + "IsActive"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  {/* <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      Created By Name
                      <a
                        onClick={(e) =>
                          ShowColumnFilterList(e, "CreatedByName")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() =>
                          LoadWithSelectedSort("CreatedByName")
                        }
                        title={"Sort By User"}
                      >
                        <span id={"imgSort" + "CreatedByName"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>Creation Time stamp</th>
                <th>Created By Username</th>
                <th>Last Updated Time stamp</th>
                <th>Is Deleted</th>
                <th>Last Updated By Name</th>
                <th>Last Updated By Usernam</th> */}
                  <th className="td-xxxs">Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.Name}</td>
                          <td>{item.IsActive == true ? "true" : "false"}</td>
                          {/* <td>{item.CreatedByName}</td>
                        <td>{formateDate(item.CreationTimestamp)}</td>
                        <td>{item.CreatedByUserName}</td>
                        <td>{item.LastUpdatedTimestamp}</td>
                        <td>{item.IsDeleted == true ? "true" : "false"}</td>
                        <td>{item.LastUpdatedByName}</td>
                        <td>{item.LastUpdatedByUserName}</td> */}
                          <td className="td-xxxs">
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  setAddEditObject(item);
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MNVMoverTypeID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Name:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Active:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsActive}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsActive: e.target.checked,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default MoverTypes;
